const FooterLangTextA: any = {
    us: {
        email_title: 'Join now for 5% off and $1,000+ exclusive coupons!',
        privacyTerms: [
            {
                text: 'Terms of Use',
                link: 'https://account.ecoflow.com/agreement/en-us/TermsOfUse.html',
            },
            {
                text: 'Privacy Policy',
                link: 'https://account.ecoflow.com/agreement/en-us/PrivacyPolicy.html',
            },
            {
                text: 'Return & Refund Policy',
                link: 'https://us.ecoflow.com/pages/ecoflow-return-policy',
            },
            {
                text: 'Warranty Policy',
                link: 'https://us.ecoflow.com/pages/warranty-policy',
            },
            {
                text: 'Security and Privacy',
                link: 'https://www.ecoflow.com/us/data-security-and-privacy',
            },
        ],
    },
    global: {
        email_title: 'Follow us for the latest news and updates.',
        PrivacyPolicy: 'Privacy Policy',
        TermsOfUse: 'Terms of Use',
        email_desc: '',
        select_country: 'Select your country or region:',
        privacyTerms: [
            {
                text: 'Terms of Use',
                link: 'https://account.ecoflow.com/agreement/en-us/TermsOfUse.html',
            },
            {
                text: 'Privacy Policy',
                link: 'https://account.ecoflow.com/agreement/en-us/PrivacyPolicy.html',
            },
            {
                text: 'Return & Refund Policy',
                link: 'https://us.ecoflow.com/pages/ecoflow-return-policy',
            },
            {
                text: 'Warranty Policy',
                link: 'https://us.ecoflow.com/pages/warranty-policy',
            },
            {
                text: 'Security and Privacy',
                link: 'https://www.ecoflow.com/us/data-security-and-privacy',
            },
        ],
    },
    // 2
    ca: {
        email_title: 'Join now for 5% off and $1,000+ exclusive coupons!',
    },
    ph: {
        email_title: 'Subscribe & get ₱500 Off coupon',
    },
    mx: {
        email_title: 'Suscríbete y obtén un cupón de MXN 200.',
    },
    jp: {
        email_title: 'メルマガ登録はこちら',
        email_desc: '新製品やセールなど、お得な最新情報をお届けするメルマガを購読して、5%OFF クーポンをゲットしよう！',
    },
};

export default FooterLangTextA;
